import { ReactNode } from "react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { Button } from "components/ui/button/Button";
import "./question-actions.scss";

interface QuestionActionsProps {
  skip?: ReactNode;
  addMore?: ReactNode;
}


export const QuestionActions = ({ skip, addMore }: QuestionActionsProps) => {
  if (!skip && !addMore) return null;

  return (
    <div className="question-actions">
      {skip}
      {addMore}
    </div>
  );
};

export const AddMoreButton = ({ label = "Add More", onClick }: { label?: string; onClick: () => void }) => (
  <div className="question-actions__add-more">
    <Button type="link-no-underline" onClick={onClick}>
      <FontAwesomeIcon icon={faPlus as IconProp} className="question-actions__add-more-icon" />
      {label}
    </Button>
  </div>
);

export default QuestionActions;
